import { render, staticRenderFns } from "./UserRowItem.vue?vue&type=template&id=af2a4bf6&scoped=true&"
import script from "./UserRowItem.vue?vue&type=script&lang=js&"
export * from "./UserRowItem.vue?vue&type=script&lang=js&"
import style0 from "./UserRowItem.vue?vue&type=style&index=0&id=af2a4bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2a4bf6",
  null
  
)

export default component.exports